import React from "react";
import ReactDOM from "react-dom";

export class SuccessPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false,
			email: ""
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handleMailingListSignUp = this.handleMailingListSignUp.bind(this);
		this.handleReturnClick = this.handleReturnClick.bind(this);
	}

	handleInputChange(event){
		this.setState({checked: !this.state.checked})
	}
	handleEmailChange(event){
		this.setState({email: event.target.value})
	}

	//Function to add user to mailing list
	//Fill in later

	async handleMailingListSignUp(){
		const response = await fetch("/mailinglist?email=" + this.state.email);
	}

	handleReturnClick(event){
		if(this.state.checked){
			this.handleMailingListSignUp(this.state.email);
		}
		window.location.href='/map';
	}

	render(){
		return (
			<div id="return-div">
				<p>Thank you for your purchase! Your receipt and the report will be arriving in your email shortly.</p>
				<p><input
					name="optIn"
					type="checkbox"
					checked={this.state.checked}
					onChange={this.handleInputChange} /><i>Yes, I would like to subscribe to TPI Report's mailing list</i></p>
				<p><input
					name="email"
					type="text"
					value={this.state.email}
					onChange={this.handleEmailChange} /></p>
				<button type="button" id="return-button" role="link" onClick={this.handleReturnClick}>
				Thanks! Return to Map
				</button>
			</div>
		)
	}
} 